import { render, staticRenderFns } from "./ColaboradoresTable.vue?vue&type=template&id=5349d5f9&scoped=true&"
import script from "./ColaboradoresTable.vue?vue&type=script&lang=js&"
export * from "./ColaboradoresTable.vue?vue&type=script&lang=js&"
import style0 from "./ColaboradoresTable.vue?vue&type=style&index=0&id=5349d5f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5349d5f9",
  null
  
)

export default component.exports